module.exports = __webpack_public_path__ + "media/images/icon_room_calendar-8613071c5e435739068ab3911efbfcb5.svg";